import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ThemeService } from './themes.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class RegionGuard implements CanActivate {
    constructor(
        private router: Router,
        private cookieService: CookieService,
        private regionService: ThemeService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const setHomepage = environment.HOMEPAGE;
        const country = route.url[0]?.path;

        if (country === 'INDIA' || country === 'USA') {
            this.cookieService.set('region', country, 365, '/');
            this.regionService._selectedRegion.next(country);
            this.router.navigate(['/', setHomepage]);
            return true;
        }
        return false;
    }
}